import { LoadingOverlay } from "../components/Loading/Loading";
import useFontLoader from "./useFontLoader";
import assetsConfig from "../assetsConfig";
import { useSettings } from "../hooks/UseSettings";
import { useLabels } from "../hooks/useLabels";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import useScriptLoader from "./useScriptLoader";

// Wait for assets, labels, fonts, scripts, and settings before rendering app
const AssetsLoader = (props: { children: React.ReactNode }) => {
	const { children } = props;
	useSettings();
	useLabels();
	const { loading: settingsLoading } = useSelector(
		(state: RootState) => state.settings,
	);
	const { loading: labelsLoading } = useSelector(
		(state: RootState) => state.labels,
	);
	const { fontsLoaded } = useFontLoader([
		assetsConfig.colors.fontBrand,
		assetsConfig.colors.fontHeading,
		assetsConfig.colors.fontCopy,
	]);
	const { scriptsLoaded } = useScriptLoader(assetsConfig.scripts);

	const allLoaded =
		Boolean(assetsConfig) &&
		Object.values(assetsConfig).length !== 0 &&
		Object.values(assetsConfig.colors).length !== 0 &&
		fontsLoaded &&
		scriptsLoaded &&
		!settingsLoading &&
		!labelsLoading;

	if (allLoaded) {
		return <>{children}</>;
	}

	return (
		<LoadingOverlay
			show={true}
			message="Loading Assets & Application Settings"
		/>
	);
};

export default AssetsLoader;
